import React, {
  useContext,
  useEffect,
  useState
} from 'react';

import {
  withRouter
} from 'react-router-dom';

import PropTypes from 'prop-types';

import {
  isMobileView,
  getSelectedProductsArrays,
  addBeforeloadEvent,
  removeBeforeloadEvent,
  filterNumbers,
  getDrivePackageImageURL
} from 'src/Utility/utility';

import {
  SalesContext
} from 'src/Context/SalesContext';

import {
  tagOnAcceptingTermsAndCondition,
  tagOnReviewOrderPageLoad
} from 'src/Tagging/NewCustomerTagging';

import OrderSummary from 'src/Components/Common/OrderSummary/OrderSummary';

import {
  Title,
  Text,
  Subtitle,
  HorizontalLine,
  WhiteTile
} from 'src/StyledComponents';

import {
  submitLead,
  submitOrderdForNewCustomer,
  submitSalesOrder
} from 'src/Services/Services';

import {
  tagOnDebiCheckExistingCustomer,
  tagOnRemoveAdditionalService,
  tagOnRequestSubmitSuccess
} from 'src/Tagging/SalesTagging';

import NewCustomerBack from 'src/Components/Common/NewCustomerBack/NewCustomerBack';

import PackageTab from 'src/Components/Common/PackageTab/PackageTab';

import FibrePackageDetails from 'src/Components/Common/FibrePackageDetails/FibrePackageDetails';

import {
  IncludedServiceComponent,
  PurplePromotionIcon,
  SubmitLeadRequestError
} from 'src/Components/Common';

import DiscountIcon from 'src/Common/SVG/DiscountIcon';

import RemovePopup from 'src/Components/Common/RemovePopup/RemovePopup';

import Trash from 'src/Components/Common/Svg/Trash';

import DebiCheck from 'src/Components/Common/DebiCheck/DebiCheck';

import {
  DeliveryDetails,
  TermsAndConditions
} from './Components';

import './ReviewOrder.css';

const ReviewOrderComp = (props) => {

  const context = useContext(SalesContext);
  const occupationType = context.vettingCreditDetails.workDetails?.occupationType?.value.toLowerCase();
  const isStudent = !!(occupationType === 'student' || occupationType === 'unemployed' || occupationType === 'casual / contractor');
  const agentUsername = sessionStorage.getItem('retailUserDetails') ? JSON.parse(sessionStorage.getItem('retailUserDetails')).username : null;

  const [ termsAcceptance, setTermsAcceptance ] = useState(isStudent ? true : false);
  const [ hasError, setHasError ] = useState(false);
  const [ formSubmitAttempt, setFormSubmitAttempt ] = React.useState(0);
  const [ _isInterests, setInterests ] = useState(false); // TODO: Should remove since value is updated, but never used .
  const [ isRemove, setIsRemove ] = useState(false);
  const [ isRemoveData, setIsRemoveData ] = useState({});

  useEffect(() => {
    addBeforeloadEvent();

    return () => {
      removeBeforeloadEvent();
    };
  }, []);

  useEffect(() => {

    const { taggingIdArray, taggingQtyArray, taggingPriceArray } = getSelectedProductsArrays(context.selectedPackage, context.selectedAdditionalServices, context.additionalServices);

    tagOnReviewOrderPageLoad(taggingIdArray, taggingQtyArray, taggingPriceArray);

    const userDetails = context.isUserExisting ? context.userDetails :  {
      contactNumber: context?.vettingCreditDetails?.contactDetails?.cellPhoneNo?.value,
      email: context?.vettingCreditDetails?.contactDetails?.email?.value,
      firstName: context?.vettingCreditDetails?.personalDetails?.firstName?.value,
      lastName: context?.vettingCreditDetails?.personalDetails?.surname?.value,
      quoteNumber: null,
      referenceNo: null
    };

    context.setUserDetailsObject(userDetails);

    if (
      context.selectedAdditionalServices.superWifi === true ||
      context.selectedAdditionalServices.voiceLine === true
    ) {
      handleInterests();
    }

    if (
      context.selectedAdditionalServices.superWifi === false ||
      context.selectedAdditionalServices.voiceLine === false
    ) {
      setInterests(false);
    }
  }, []);

  const closeError = () => {
    setHasError(false);
  };

  const selectedPackageSpeed =
    filterNumbers(context.selectedPackage.download) +
    '/' +
    context.selectedPackage.upload;

  const selectedPackageData = {
    imageUrl: getDrivePackageImageURL(context.selectedPackage.provider),
    type: `Fibre ${ context.selectedPackage.dataCap.toLowerCase() }`,
    speed: selectedPackageSpeed,
    price: `R${ context.selectedPackage.productPrice.value } PM`,
    contractTerm: context.selectedContractTerm
  };

  const selectedAdditionalServiceKeys = Object.keys(context.selectedAdditionalServices)
    .filter((e) => context.selectedAdditionalServices[e] === true);

  let selectedAdditionalServices = [];
  let additionalServicesVAS = [];

  if (context.additionalServices && context.additionalServices.serviceCategories) {
    context.additionalServices.serviceCategories.map((service) => {
      if (!service.offerId) {
        additionalServicesVAS.push(service);
      }
    });
  }

  if (additionalServicesVAS) {
    selectedAdditionalServices = additionalServicesVAS.filter((e) =>
      selectedAdditionalServiceKeys.find((key) => key === e.vasCategory)
    );
  }

  const submitLeadIfOrderFailed = () => {
    submitLead(context)
      .then((res) => {
        context.setUserDetails({
          key: 'referenceNo',
          value: res.result && res.result.referenceNumber
        });
        window.scrollTo(0, 0);
        props.history.push('/cloud/fibre/sales/leadConfirmation');
        context.setShowSpinner(false);
      })
      .catch((error) => {
        console.error('[Quotation][submitSalesOrder][submitSalesOrder-Failed]');
        console.error(error);
        if (formSubmitAttempt < 3) {
          setHasError(true);
          setFormSubmitAttempt(formSubmitAttempt + 1);
        } else {
          setHasError(false);
          context.setNewCustomerErrorObject(error);
          window.scrollTo(0, 0);
          props.history.push('/cloud/fibre/sales/error');
        }
        context.setShowSpinner(false);
      });
  };

  const submitSalesOrderForExistingCustomer = () => {

    if (agentUsername) {

      context.setShowSpinner(false);
      props.history && props.history.push('/cloud/fibre/sales/CustomerApproval');

      return;
    }

    context.setShowSpinner(true);

    submitSalesOrder(context)
      .then((response) => {
        console.log(
          '[Quotation][submitSalesOrder][submitSalesOrder-Success]'
        );
        context.setUserDetails({
          key: 'quoteNumber',
          value: response.result && response.result.quoteNumber
        });
        context.setShowSpinner(false);

        const { taggingIdArray, taggingQtyArray, taggingPriceArray } = getSelectedProductsArrays(context.selectedPackage, context.selectedAdditionalServices, context.additionalServices);

        tagOnRequestSubmitSuccess(
          response.result && response.result.quoteNumber,
          'EC Order success',
          taggingIdArray,
          taggingQtyArray,
          taggingPriceArray,
          context.isUserExisting,
          context.userDetails.contactNumber
        );
        props.history.push('/cloud/fibre/sales/success');
      })
      .catch((error) => {
        console.error(
          '[Quotation][submitSalesOrder][submitSalesOrder-Failed]'
        );
        console.error(error);

        if (formSubmitAttempt < 3) {
          setHasError(true);
        } else {
          setHasError(false);
          submitLeadIfOrderFailed();
          props.history.push('/cloud/fibre/sales/error');
        }
        context.setShowSpinner(false);
      });
  };

  const submitOrder = () => {
    setHasError(false);

    if(context.isUserExisting){

      submitSalesOrderForExistingCustomer();

      return;
    }

    if (formSubmitAttempt > 3) {
      window.scrollTo(0, 0);
      props.history.push('/cloud/fibre/sales/error');

      return;
    }

    context.setShowSpinner(true);
    setFormSubmitAttempt(formSubmitAttempt + 1);
    if (isStudent) {
      submitLeadIfOrderFailed();
    }else if (agentUsername) {

      context.setShowSpinner(false);
      props.history && props.history.push('/cloud/fibre/sales/CustomerApprovalNewCustomer');
    } else {
      submitOrderdForNewCustomer(context)
        .then((_response) => {
          context.setShowSpinner(false);
          props.history && props.history.push('/cloud/fibre/sales/confirmation');
        })
        .catch((_error) => {
          if (formSubmitAttempt < 3) {
            setHasError(true);
          } else {
            setHasError(false);
            submitLeadIfOrderFailed();
          }
          context.setShowSpinner(false);
        });
    }
  };

  function handleRemove() {
    let addVas = context.additionalVas;
    if (addVas) {
      for (let index = 0; index < addVas.length; index++) {
        if (addVas[index].category === isRemoveData.category) {
          addVas.splice(index, 1);
        }
      }
    }
    context.setSelectedAdditionalServices({ key: isRemoveData.category, value: false });
    context.setAdditionalVas(addVas);
    tagOnRemoveAdditionalService(isRemoveData.acronym, 1, isRemoveData.priceDescription);
    hideRemovePopup();
  }

  function handleInterests() {
    setInterests(true);
  }

  const showRemovePopup = (item) => {
    setIsRemoveData(item);
    setIsRemove(true);
  };

  const hideRemovePopup = () => {
    setIsRemove(false);
  };

  const openTermsAndConditionView = () => {

    props.history.push('/cloud/fibre/sales/extTermsAndConditionLink');

  };

  return (

    <>

      <NewCustomerBack
        title="Back to delivery"
        backUrl={ context.isUserExisting ? '/cloud/fibre/sales/deliveryAddress' : context.isUnemployed ? '/cloud/fibre/sales/credit-vetting' : '/cloud/fibre/sales/upload-documents'}
      />

      <div className="sales-review-order__container">

        <div className="sales-review-order__main">
          <Title
            style={{ marginBottom: '1rem' }}
            className="sales-review-order__web-only">

            {' '}
            Review your order
          </Title>

          <Text automationid="SalesLeads_P_ReviewOrder_1">
            Make sure you’re 100% happy before continuing.
          </Text>

          { !isStudent ?
            <div
              className="sales-review-order__mobile-only"
            >
              <Subtitle automationid="SalesLeads_H4_ReviewOrder_3">
                  The fine print:
              </Subtitle>
              <TermsAndConditions
                onChange={(_e) => {
                  setTermsAcceptance(!termsAcceptance);
                  if (!termsAcceptance) {
                    tagOnAcceptingTermsAndCondition();
                  }
                }}
                checked={termsAcceptance}
                openTandC={openTermsAndConditionView}
              />
            </div>
            :
            null
          }

          <Subtitle automationid="SalesLeads_H4_ReviewOrder_6">
            {
              isStudent ? 'Your order:' : 'You’re about to purchase:'
            }
          </Subtitle>

          { isMobileView() ?

            <WhiteTile automationid="SalesLeads_Div_ReviewOrder_10">
              <Text automationid="SalesLeads_P_ReviewOrder_21">
                {
                  isStudent ? '1 Item' : 'Your order'
                }</Text>
              <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_1" />
              <PackageTab data={selectedPackageData} />
              <FibrePackageDetails speed={selectedPackageData.speed} type={selectedPackageData.type}></FibrePackageDetails>
              {
                (context.selectedPackageType === 'Vodacom One Deals' || context.selectedPackageType === 'Premium Fibre Deals') && context.selectedPackage?.inclusions?.length > 0 ?
                  <IncludedServiceComponent
                    inclusionsList={context.selectedPackage?.inclusions}
                    bgcolor="#FFFFF"
                    isDevice={false}
                  />
                  :
                  null
              }
              <div className="mobile-price">
                {context.selectedContractTerm && context.selectedPackage.onDiscount &&

                    <p className='generic-discount-container review-order-discount'>
                      <PurplePromotionIcon />
                      <Text
                        lineheight="0"
                        fontWeight="700"
                        fontSize="14px"
                        color="#9C2AA0"
                        paddingLeft="5px"
                        automationid={`SalesLeads_p_packageDiscount${ context.selectedPackage.discountAmount }_2`}
                      >
                        R{context.selectedPackage.discountAmount} off for {parseInt(context.selectedPackage?.discountTerm) === '1' ? '1 month' : `${ parseInt(context.selectedPackage?.discountTerm) } months`}
                      </Text>
                    </p>
                }
                <Text
                  style={context.selectedContractTerm ? { textAlign: 'right'} : {textAlign: 'right', width: '100%'}}
                  automationid="SalesLeads_P_ReviewOrder_41"
                  fontSize="16px"
                >
                  <span
                    style={{ fontWeight: 'bold' }}
                  >
                    {'  '} {`R${ context.selectedPackage.productPrice.value } ${ context.selectedContractTerm === '12 Months' ? 'x 12' : context.selectedContractTerm === '24 Months' ? 'x 24' : '' }`}
                  </span>
                </Text>
              </div>
              {
                context.additionalVas ?
                  context.additionalVas.map((item, key) => {
                    if (item.category === 'superWifi') {
                      return (
                        <div key={key}>
                          <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_2" />
                          <div className="additional-vas">
                            <div className="image-wrapper">
                              <img src={item?.imgUrl} />
                              <div>
                                <p className="quantity-additional-vas">Qty: 1</p>
                              </div>
                            </div>
                            <div className="additional-vas-wrapper">
                              <div className="tbyb-promotion-review">Try before you buy</div>
                              <div className="details-wrapper">
                                <div className="details-lte">
                                  <p className="lte-text">{item?.displayName}</p>
                                </div>

                                <div className="wrapperAdditional">
                                  <p
                                    className="priceAdditional"
                                  >
                                    {item?.price} {parseInt(item?.contractTerm) ? 'PM' : ''}
                                  </p>
                                </div>
                              </div>
                              <div className="promotion-text">FREE 14-day trial</div>
                              {
                                item.discount ?
                                  <div className="discount-text-wrapper">
                                    <DiscountIcon></DiscountIcon>
                                    <div className="discount-text">{item.discount}</div>
                                  </div>
                                  :
                                  null
                              }
                              <button onClick={() => showRemovePopup(item)} className="remove-btn">
                                <Trash className="trash" />
                                <span className="remove">Remove</span>
                              </button>
                              {
                                isRemove ?
                                  <RemovePopup
                                    close={hideRemovePopup}
                                    onClick={() => {
                                      handleRemove();
                                    }}
                                    text={`You are about to remove the ${ isRemoveData.displayName } service from your order.`}
                                  >
                                  </RemovePopup>
                                  :
                                  null
                              }
                            </div>
                          </div>
                        </div>
                      );
                    } else {
                      return (
                        <div key={key}>
                          <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_2" />
                          <div className="additional-vas">
                            <div className="image-wrapper" style={{ paddingTop: '0px' }}>
                              <img src={item?.imgUrl} />
                              <div>
                                <p className="quantity-additional-vas">Qty: 1</p>
                              </div>
                            </div>
                            <div className="additional-vas-wrapper">
                              <div className="details-wrapper">
                                <div className="details-lte">
                                  <p className="lte-text">{item?.displayName}</p>
                                </div>

                                <div className="wrapperAdditional">
                                  <p
                                    className="priceAdditional"
                                  >
                                    {item?.price} {parseInt(item?.contractTerm) || item.category === 'contractCover' ? 'PM' : ''}
                                  </p>
                                </div>
                              </div>
                              <div className="promotion-text">{item.category === 'contractCover' ? 'Pays for your contract expenses in the event of death' : ''}</div>
                              <button onClick={() => showRemovePopup(item)} className="remove-btn" style={{ paddingTop: '3em' }}>
                                <Trash className="trash" />
                                <span className="remove">Remove</span>
                              </button>
                              {
                                isRemove ?
                                  <RemovePopup
                                    close={hideRemovePopup}
                                    onClick={() => {
                                      handleRemove();
                                    }}
                                    text={`You are about to remove the ${ isRemoveData.displayName } service from your order.`}
                                  >
                                  </RemovePopup>
                                  :
                                  null
                              }
                            </div>
                          </div>
                        </div>
                      );
                    }
                  })
                  :
                  null
              }
            </WhiteTile>
            :
            <WhiteTile automationid="SalesLeads_Div_ReviewOrder_10">

              <Text automationid="SalesLeads_P_ReviewOrder_21">1 Item</Text>

              <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_1" />

              <PackageTab data={selectedPackageData} />

              <FibrePackageDetails speed={selectedPackageData.speed} type={selectedPackageData.type}></FibrePackageDetails>

              { (context.selectedPackageType === 'Vodacom One Deals' || context.selectedPackageType === 'Premium Fibre Deals') && context.selectedPackage?.inclusions?.length > 0 ?
                <IncludedServiceComponent
                  inclusionsList={context.selectedPackage?.inclusions}
                  bgcolor="#FFFFF"
                  isDevice={false}
                />
                :
                null
              }
              { context.additionalVas ?
                context.additionalVas.map((item, key) => {
                  if (item.category === 'superWifi') {
                    return (
                      <div key={key}>
                        <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_1" />
                        <div className="additional-vas">
                          <div className="image-wrapper">
                            <img src={item.imgUrl} />
                          </div>
                          <div className="additional-vas-wrapper">
                            <div className="tbyb-promotion-review">Try before you buy</div>
                            <div className="details-wrapper">
                              <div className="details-lte">
                                <p className="lte-text">{item?.displayName}</p>
                              </div>
                              <div><p className="quantity-additional-vas">Qty: 1</p></div>
                              <div className="wrapperAdditional">
                                <p
                                  className="priceAdditional"
                                >
                                  {item?.price} {parseInt(item?.contractTerm) ? 'PM' : ''}
                                </p>
                              </div>
                            </div>
                            <button onClick={() => showRemovePopup(item)} className="remove-btn">
                              <Trash className="trash" />
                              <span className="remove">Remove</span>
                            </button>
                            <div className="promotion-text">FREE 14-day trial</div>
                            {
                              item.discount ?
                                <div className="discount-text-wrapper">
                                  <DiscountIcon></DiscountIcon>
                                  <div className="discount-text">{item.discount}</div>
                                </div>
                                :
                                null
                            }
                          </div>
                          {
                            isRemove ?
                              <RemovePopup
                                close={hideRemovePopup}
                                onClick={() => {
                                  handleRemove();
                                }}
                                text={`You are about to remove the ${ isRemoveData.displayName } service from your order.`}
                              >
                              </RemovePopup>
                              :
                              null
                          }
                        </div>
                      </div>
                    );
                  } else {
                    return (
                      <div key={key}>
                        <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_1" />
                        <div className="additional-vas">
                          <div className="image-wrapper">
                            <img src={item.imgUrl} style={{ paddingLeft: '20px' }} />
                          </div>
                          <div className="additional-vas-wrapper">
                            <div className="details-wrapper">
                              <div className="details-lte">
                                <p className="lte-text">{item?.displayName}</p>
                              </div>
                              <div className="wrapperAdditional">
                                <p
                                  className="priceAdditional"
                                >
                                  {item?.price} {parseInt(item?.contractTerm) || item.category === 'contractCover' ? 'PM' : ''}
                                </p>
                              </div>
                            </div>
                            <button onClick={() => showRemovePopup(item)} className="remove-btn">
                              <Trash className="trash" />
                              <span className="remove">Remove</span>
                            </button>
                            <div className="promotion-text">{item.category === 'contractCover' ? 'Pays for your contract expenses in the event of death' : ''}</div>
                          </div>
                          {
                            isRemove ?
                              <RemovePopup
                                close={hideRemovePopup}
                                onClick={() => {
                                  handleRemove();
                                }}
                                text={`You are about to remove the ${ isRemoveData.displayName } service from your order.`}
                              >
                              </RemovePopup>
                              :
                              null
                          }
                        </div>
                      </div>
                    );
                  }
                })
                :
                null
              }
            </WhiteTile>
          }

          {
            context.lteReviewData ?
              <div>
                <Subtitle automationid="">
                  Additional services
                </Subtitle>

                <WhiteTile automationid="SalesLeads_Div_ReviewOrder_10">

                  <div className="image-wrapper">
                    {props.lteImageUrl ?
                      <img src={props.lteImageUrl} />
                      :
                      <img src="https://content.vodacom.co.za/content/fibre/sales/images/saleslead_red_world_icon.svg" />
                    }
                  </div>

                  <div className="details-lte">
                    <div
                      className=""
                    >
                      {context.lteReviewData.promotion ?
                        <p className="service-promotion-review" >{context.lteReviewData.promotion}</p>
                        :
                        null
                      }
                    </div>

                    {context.lteReviewData.displayName ?

                      <p className="lte-text">{context.lteReviewData.displayName}</p>
                      :
                      null
                    }
                    {/* <p automationid="" className="">1 Item</p> */}
                  </div>

                  <div className="wrapperAdditional">
                    <p
                      className="priceAdditional"
                    >{`${ context.lteReviewData.price } PM`}
                    </p>
                    <button onClick={showRemovePopup.bind()} className="remove-btn">
                      <Trash className="trash" />
                      <span className="remove">Remove</span>
                    </button>
                  </div>

                  {
                    isRemove ?
                      <RemovePopup
                        close={hideRemovePopup}
                        onClick={handleRemove}
                        text={'You are about to remove the interim LTE service from your order.'}
                      >
                      </RemovePopup>
                      :
                      null
                  }

                  <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_1" />

                  <p>After the first month, you can stay connected on your preferred LTE plan. Once fibre is up and running, the LTE service will stop and you&apos;ll pay for the fibre line instead.</p>

                  {/* <PackageTab data={selectedPackageData} /> */}
                  <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_2" />

                  <Text
                    style={{ textAlign: 'right' }}
                    automationid="SalesLeads_P_ReviewOrder_41"
                  >
                    <span
                      style={{ color: '#666', marginRight: '5px' }}
                    >
                      Total:{' '}
                    </span>

                    {context.lteReviewData.price ?
                      <span
                        style={{ fontWeight: 'bold' }}
                      >
                        {`${ context.lteReviewData.price }`}
                      </span>
                      :
                      null
                    }
                  </Text>
                </WhiteTile>
              </div>
              :
              null
          }

          {
            selectedAdditionalServices.length > 0 ?
              <div
                className="sales-review-order__web-only"
              >
                <Subtitle automationid="SalesLeads_H4_ReviewOrder_31">
                  I’m also interested in
                </Subtitle>

                <WhiteTile automationid="SalesLeads_Div_ReviewOrder_233">
                  <Text automationid="SalesLeads_P_ReviewOrder_21">

                    {selectedAdditionalServices.length > 1 ?
                      `${ selectedAdditionalServices.length } items` :
                      `${ selectedAdditionalServices.length } item`
                    }
                  </Text>
                  <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_1" />
                  <PackageTab data={selectedAdditionalServices} />
                </WhiteTile>
              </div>
              :
              null
          }

          {/* Mobile View Design */}
          {
            selectedAdditionalServices.length > 0 ?
              <div
                className="sales-review-order__mobile-only"
              >
                <WhiteTile automationid="SalesLeads_Div_ReviewOrder_39">

                  <Text automationid="SalesLeads_P_ReviewOrder_43">
                    I’m also interested in
                  </Text>

                  <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_5" />
                  <PackageTab data={selectedAdditionalServices} />
                  <HorizontalLine automationid="SalesLeads_Hr_ReviewOrder_6" />
                  <Text
                    style={{ textAlign: 'right' }}
                    automationid="SalesLeads_P_ReviewOrder_44"
                  >
                    <span
                      style={{ color: '#666', marginRight: '5px' }}
                    >
                      Total due now:{' '}
                    </span>
                    <span
                      style={{ fontWeight: 'bold' }}
                    >
                      {`R${ context.selectedPackage.productPrice.value } PM`}
                    </span>
                  </Text>
                </WhiteTile>
              </div>
              :
              null
          }

          {context.isUserExisting && <>

            <Subtitle>DebiCheck</Subtitle>

            <WhiteTile>

              <DebiCheck
                setDebiCheck={() => {
                  if (!context.debiCheckSelected){
                    tagOnDebiCheckExistingCustomer();
                  }
                  context.setDebiCheckSelected(!context.debiCheckSelected);
                }}
                value={context.debiCheckSelected}
              />
            </WhiteTile>

          </>
          }

          <DeliveryDetails />
          {
            !isStudent ?
              <div
                className="sales-review-order__web-only"
              >
                <TermsAndConditions
                  onChange={(_e) => {
                    setTermsAcceptance(!termsAcceptance);
                    if (!termsAcceptance) {
                      tagOnAcceptingTermsAndCondition();
                    }
                  }}
                  openTandC={openTermsAndConditionView}
                  checked={termsAcceptance}
                />
              </div>
              :
              null
          }

        </div>

        <OrderSummary
          isEnabled={termsAcceptance}
          submitTitle="Submit order"
          submitRoute="/cloud/fibre/sales/confirmation"
          nextCallBack={submitOrder}
          setReviewDataEmpty={!context.lteReviewData}
        />

        {hasError && (
          <SubmitLeadRequestError close={closeError} reSubmit={submitOrder} />
        )}
      </div>
    </>
  );
};

ReviewOrderComp.propTypes = {
  lteImageUrl: PropTypes.string
};

export default withRouter(ReviewOrderComp);
